import type { IPlatformCatalog } from '@platform/dao';

/**
 * Кількість шаблонів глобального каталогу (прототип v4 Object.keys(TEMPLATES).length — «Каталог модулів 169», «Форми 169»): типи записів
 * глобального каталогу з позицією в порядку TEMPLATES (сервер без позицій — усі його типи); каталог ще не завантажено — undefined.
 * Чиста функція.
 */
export function globalTemplateCount(platform: IPlatformCatalog | undefined): number | undefined {
  if (!platform) return undefined;
  return platform.recordTypes.filter((r) => r.order !== null).length || platform.recordTypes.length;
}
